<template>
  <div class="lang-switcher" :class="{ active: isOpen }">
    <button class="lang-btn" @click.stop="toggleLang" v-if="languageInfo">
      <!-- <span class="lang-flag">{{ languageInfo.flag }}</span> -->
      <span>{{ languageInfo.shortname }}</span>
      <i class="el-icon-arrow-down" :class="{ rotated: isOpen }" />
    </button>
    <div class="lang-dropdown" @click.stop>
      <div v-for="lang in languages" :key="lang.lang" class="lang-option"
        :class="{ active: languageInfo.lang === lang.lang }" @click="selectLang(lang)">
        <!-- <span class="lang-flag">{{ lang.flag }}</span> -->
        <span>{{ lang.shortname }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getIndexLanguagesApi } from '@/api/api'
export default {
  name: 'LangSwitcher',
  data() {
    return {
      isOpen: false,
      languages: [],
    }
  },
  computed: {
    ...mapState(['languageInfo']),
  },
  mounted() {
    getIndexLanguagesApi().then(res => {
      this.languages = res.data
      if (!this.languageInfo) {
        this.selectLang(this.languages[0])
      }
    }).catch(() => { })

  },
  methods: {
    toggleLang() {
      this.isOpen = !this.isOpen
    },
    selectLang(langInfo) {
      this.$i18n.locale = langInfo.lang
      this.$store.commit("SET_LANGUAGE_INFO", langInfo);
      window.location.reload();
      setTimeout(() => {
        this.isOpen = false
      }, 100)
    },
  }
}
</script>

<style lang="scss" scoped>
.lang-switcher {
  position: relative;
  z-index: 100;

  .lang-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 0.75rem;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    color: #f1f5f9;
    font-size: 0.875rem;
    cursor: pointer;
    transition: all 0.3s;
    backdrop-filter: blur(10px);

    &:hover {
      background: rgba(255, 255, 255, 0.1);
      border-color: #6366f1;
    }

    i {
      font-size: 0.75rem;
      color: #94a3b8;
      transition: transform 0.3s;

      &.rotated {
        transform: rotate(180deg);
      }
    }

    .lang-flag {
      font-size: 1rem;
    }
  }

  .lang-dropdown {
    position: absolute;
    top: calc(100% + 0.5rem);
    right: 0;
    min-width: 200px;
    max-height: 400px;
    overflow-y: auto;
    background: rgba(15, 15, 26, 0.98);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    padding: 0.5rem;
    opacity: 0;
    visibility: hidden;
    transform: translateY(-10px);
    transition: all 0.3s ease;
    z-index: 1001;
    backdrop-filter: blur(20px);
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);

    &::-webkit-scrollbar {
      width: 0px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(255, 255, 255, 0.05);
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(255, 255, 255, 0.2);
      border-radius: 3px;

      &:hover {
        background: rgba(255, 255, 255, 0.3);
      }
    }

    .lang-option {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      padding: 0.625rem 0.75rem;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.2s;
      font-size: 0.875rem;
      color: #cbd5e1;
      position: relative;
      margin-bottom: 5px;

      &:hover {
        background: rgba(99, 102, 241, 0.15);
        color: #f1f5f9;
      }

      &.active {
        background: linear-gradient(135deg, rgba(99, 102, 241, 0.2), rgba(168, 85, 247, 0.2));
        color: #f1f5f9;

        .check-icon {
          margin-left: auto;
          font-size: 0.75rem;
          color: #818cf8;
        }
      }

      .lang-flag {
        font-size: 1.125rem;
      }
    }
  }

  &.active .lang-dropdown {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
}

// 响应式
@media (max-width: 768px) {
  .lang-switcher {
    .lang-btn {
      padding: 0.4rem 0.6rem;

      span:not(.lang-flag) {
        display: none;
      }

      i {
        display: none;
      }
    }

    .lang-dropdown {
      min-width: 160px;
    }
  }
}
</style>